import * as React from 'react';

import * as styles from './styles/header.css';
import { Header } from '../../../base/Header';

export interface IGroupsHeaderStoreProps {
  email: string | null;
}

export function GroupsHeader({ email }: IGroupsHeaderStoreProps) {
  return (
    <Header>
      <div className={styles['content']}>
        <div className={styles['title']}>Управление подписками</div>
        <div className={styles['email']}>{email}</div>
      </div>
    </Header>
  );
}
